import React, {useContext, useEffect} from 'react';
import './Feedback.scss';
import {Loader} from '../_common';
import {I18nContext} from '../../contexts/i18nContext';
import {AdminContext} from '../../contexts/adminContext';
import {FeedbackContext} from '../../contexts/feedbackContext';
import {setUTCDate} from "../../helpers/helpers";

const Feedback = () => {
  const { t } = useContext(I18nContext);
  const { usersForDropdowns, getUsersForDropdowns } = useContext(AdminContext);
  const { pending, feedback, getFeedback } = useContext(FeedbackContext);

  useEffect(() => {
    getUsersForDropdowns();
    getFeedback();
  }, []);

  const getLocationText = location => {
    switch (location) {
      case '/':
        return t('projects');
      case '/selections':
        return t('selections');
      case '/profile':
        return t('profile');
      case '/admin':
        return t('admin panel');
      case '/feedback':
        return t('feedback');
      default:
        return t('not recognized');
    }
  }

  return (
    <div className='Feedback'>
      <div className='header'>
        <div className='headerTitle'>{t('feedback')}</div>
        <div className='headerButtons'>
        </div>
      </div>

      <div className='feedbackList'>
        {(pending || !usersForDropdowns.length) && (
          <div className='loaderWrapper'><Loader /></div>
        )}

        {!pending && feedback.sort((a, b) => b.localDateTime.localeCompare(a.localDateTime)).map(item => (
          <div className='feedbackItem' key={item?.id}>
            <div className='feedbackItemContent'>
              <div className='feedbackItemHeader'>
                <div className='feedbackHeaderItemLight'>
                  {
                    new Date(setUTCDate(item?.localDateTime)).toLocaleDateString('pl-PL') +
                    ' ' +
                    new Date(setUTCDate(item?.localDateTime)).toLocaleTimeString('pl-PL')
                  }
                </div>
                <div className='feedbackHeaderItem'>
                  {usersForDropdowns.find(x => x.id === item?.userId)?.firstName + ' ' + usersForDropdowns.find(x => x.id === item?.userId)?.lastName + ' - ' + item.email}
                </div>
                <div className='feedbackHeaderItemLight'>
                  {t('tab') + ': ' + getLocationText(item?.userLocation)}
                </div>
              </div>
              <div className='feedbackItemTitle'>
                {item?.title}
              </div>
              <div className='feedbackItemText'>
                {item?.text}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
};

export default Feedback;
